import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@cimpress/react-components';
import Button from './Button';

class ReadMorePopover extends Component {
  static defaultProps = {};

  static propTypes = {
    contents: PropTypes.node,
    readMoreContents: PropTypes.node
  };

  state = {
    showPopover: false,
    readMoreClicked: false
  };

  setReadMore = () => {
    this.setState({ readMoreClicked: true });
  };

  setReadLess = () => {
    this.setState({ readMoreClicked: false });
  };

  showPopover = () => {
    this.setState({ showPopover: true });
  };

  onClickOutside = () => {
    this.state.showPopover && this.setState({ showPopover: false, readMoreClicked: false });
  };

  render() {
    const { contents, readMoreContents, children, ...props } = this.props;
    const contentToRender = !this.state.readMoreClicked ? (
      <div>
        {contents}
        {readMoreContents && (
          <Button bsStyle="link" onClick={this.setReadMore}>
            Read more...
          </Button>
        )}
      </div>
    ) : (
      <div>
        {contents}
        <br />
        {readMoreContents}
        {readMoreContents && (
          <Button bsStyle="link" onClick={this.setReadLess}>
            Read less...
          </Button>
        )}
      </div>
    );

    return (
      <Tooltip
        contents={contentToRender}
        {...props}
        onClickOutside={this.onClickOutside}
        show={this.state.showPopover}
        direction="left">
        <div onClick={this.showPopover} style={{ cursor: 'pointer' }}>
          {children}
        </div>
      </Tooltip>
    );
  }
}

export default ReadMorePopover;
